import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './ActiveList.css?v=1.0';
import { ServiceSearchPatient } from "../Services/Service";
import Table from './DataTable/DataTable';
import { CustomLoader } from "../Services/CommonLibrary"

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');
const SearchResult = React.memo(({ results, msg }) => {
    return (
        <table class="table">
            <thead class="">
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Mobile</th>
                    <th scope="col">Email</th>
                    <th scope="col">NHS ID</th>
                    <th scope="col">Program</th>
                </tr>
            </thead>
            <tbody>
                {!msg ?
                    results.map((row, i) => (
                        <tr key={i}>
                            <td>{row.name}</td>
                            <td>{row.mobile}</td>
                            <td>{row.email}</td>
                            <td>{row.nhsNumber}</td>
                            <td>{row.programName}</td>
                        </tr>
                    )
                    )
                    :
                    <tr>
                        <td colSpan={4} id='fontSizetd'>{msg}</td>
                    </tr>}
            </tbody>
        </table>
    );
});

function SearchPatient() {

    const clickhandler = name => console.log("delete", name);
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState([]);
    const [srchtxt, setSrchtxt] = useState('');
    const [showMsg, setShowMsg] = useState('');

    var storage = JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    var programId = 'all';

    useEffect(() => {
        // fetchProgramDetails('all', 1, limit, programId);
    }, []);

    const fetchPatientDetails = async () => {
        setLoading(true);
        ServiceSearchPatient(srchtxt)
            .then((res) => {
                if (res.data.status == 0) {
                    setServiceData(res.data.data);
                    setShowMsg('');
                } else {
                    setShowMsg(res.data.data);
                }

                setLoading(false);
            });
    }
    const handleSearch = useCallback(() => {
        if (srchtxt.length > 0) {
            fetchPatientDetails();
        }
    }, [srchtxt]);
    return (
        <section className='projects-section' style={{ overflow: "inherit" }}>
            <div className='row'>
                <div className="FL">
                    <div class="input-group">
                        <input type="search" class="form-control rounded" required placeholder="Search by Name, Mobile Number or NHS Number" aria-label="Search" aria-describedby="search-addon" onChange={(e) => setSrchtxt(e.target.value)} onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSearch();
                            }
                        }} />&nbsp;
                        <button type="button" class="btn btn-success" onClick={handleSearch}>search</button>
                    </div>
                    <div className='table-responsive pt-10' style={{ overflowX: "inherit" }} id='modalityLifestyle'>
                        <SearchResult results={serviceData} msg={showMsg} />
                    </div>
                </div>
            </div>
            {loading ? <CustomLoader /> : null}
        </section>


    );
}
export default SearchPatient;